import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateRegion } from 'API/Region/updateRegion';

const useUpdateRegion = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (regionData) => {
        const response = await updateRegion(regionData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['Regions'] });
            queryClient.invalidateQueries({
                queryKey: ['Region', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateRegion;
